import { RootState } from 'models/store';

// ==============================|| ACCOUNT SELECTORS ||============================== //

export const selectRealm = (state: RootState) => state.account.realm;

export const selectTenant = (state: RootState) => state.account.tenant;

export const selectAccountInfo = (state: RootState) =>
  state.account.account?.accountInfo;

export const selectAccountInfoUserId = (state: RootState) =>
  state.account.account?.accountInfo?.sub;

export const selectSelectedEmsMemberAccount = (state: RootState) =>
  state.account.selectedEmsMemberAccount;
